import React, { FC } from "react";

import { Helmet } from "react-helmet-async";

import {
    BvvmLogo,
    BvvmLogoLight,
    MyBrokerLogo,
    MyBrokerLogoLight,
    SquareBvvmLogo,
    SquareMyBrokerLogo,
} from "@/assets/images";
import config from "@/config";

type LogoProps = {
    variant: "square" | "light" | "default" | "favicon";
    officeId: string | null;
};

const Logo: FC<LogoProps> = ({ variant, officeId }) => {
    if (officeId !== null && config.BVMM_OFFICE_LIST.includes(officeId)) {
        switch (variant) {
            case "favicon":
                return (
                    <Helmet>
                        <link
                            rel="shortcut icon"
                            id="favicon"
                            href={`${config.PUBLIC_URL}/bvvm/favicon.ico`}
                            type="any"
                        />
                        <link
                            rel="apple-touch-icon"
                            sizes="180x180"
                            href={`${config.PUBLIC_URL}/bvvm/apple-touch-icon.png`}
                        />
                        <link
                            rel="icon"
                            type="image/png"
                            sizes="32x32"
                            href={`${config.PUBLIC_URL}/bvvm/favicon-32x32.png`}
                        />
                        <link
                            rel="icon"
                            type="image/png"
                            sizes="16x16"
                            href={`${config.PUBLIC_URL}/bvvm/favicon-16x16.png`}
                        />
                    </Helmet>
                );
            case "square":
                return <SquareBvvmLogo />;
            case "light":
                return <BvvmLogoLight />;
            case "default":
                return <BvvmLogo />;
        }
    }
    switch (variant) {
        case "favicon":
            return (
                <Helmet>
                    <link rel="shortcut icon" id="favicon" href={`${config.PUBLIC_URL}/favicon.ico`} type="any" />
                    <link rel="apple-touch-icon" sizes="180x180" href={`${config.PUBLIC_URL}/apple-touch-icon.png`} />
                    <link rel="icon" type="image/png" sizes="32x32" href={`${config.PUBLIC_URL}/favicon-32x32.png`} />
                    <link rel="icon" type="image/png" sizes="16x16" href={`${config.PUBLIC_URL}/favicon-16x16.png`} />
                </Helmet>
            );
        case "square":
            return <SquareMyBrokerLogo />;
        case "light":
            return <MyBrokerLogoLight />;
        case "default":
            return <MyBrokerLogo />;
    }
    return <></>;
};

export default Logo;
